import { useEffect } from 'react';

interface IClickAwayProps {
	ref: any;
	open: boolean;
	onClickAway: () => void;
	onClickInside?: () => void;
	onEscape?: () => void;
	onMousedownClickAway?: () => void;
	onMousedownClickInside?: () => void;
}

const useClickAwayListener = ({
	ref,
	onClickAway,
	onClickInside,
	onMousedownClickAway,
	onMousedownClickInside,
	onEscape,
	open,
}: IClickAwayProps): void => {

	useEffect(() => {
		const handleClickOutside = (event: MouseEvent) => {
			if (!open) return;
			if (!ref?.current?.contains?.(event.target)) {
				onClickAway();
			} else {
				onClickInside?.();
			}
		};

		const handleMouseDownClickOutside = (event: MouseEvent) => {
			if (!open) return;
			if (!ref?.current?.contains?.(event.target)) {
				onMousedownClickAway?.();
			} else {
				onMousedownClickInside?.();
			}
		};

		const handleKeypress = (event: KeyboardEvent) => {
			if (open && event.key === 'Escape') {
				event.preventDefault();
				onEscape?.();
			}
		};

		document.addEventListener('click', handleClickOutside);
		document.addEventListener('mousedown', handleMouseDownClickOutside);
		document.addEventListener('keydown', handleKeypress);
		return () => {
			document.removeEventListener('click', handleClickOutside);
			document.removeEventListener('mousedown', handleMouseDownClickOutside);
			document.removeEventListener('keydown', handleKeypress);
		};
	}, [ref, onClickAway, onClickInside, onEscape, open, onMousedownClickAway, onMousedownClickInside]);
};

export default useClickAwayListener;
